import { render, staticRenderFns } from "./task.vue?vue&type=template&id=9daf6fec&scoped=true"
import script from "./task.vue?vue&type=script&lang=js"
export * from "./task.vue?vue&type=script&lang=js"
import style0 from "./task.vue?vue&type=style&index=0&id=9daf6fec&prod&scoped=true&lang=css"
import style1 from "./task.vue?vue&type=style&index=1&id=9daf6fec&prod&lang=scss&scoped=true"
import style2 from "./task.vue?vue&type=style&index=2&id=9daf6fec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9daf6fec",
  null
  
)

export default component.exports